var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 6.66665V4.99998C1.66663 4.55795 1.84222 4.13403 2.15478 3.82147C2.46734 3.50891 2.89127 3.33331 3.33329 3.33331H16.6666C17.1087 3.33331 17.5326 3.50891 17.8451 3.82147C18.1577 4.13403 18.3333 4.55795 18.3333 4.99998V15C18.3333 15.442 18.1577 15.8659 17.8451 16.1785C17.5326 16.4911 17.1087 16.6666 16.6666 16.6666H11.6666M1.66663 9.99998C3.37277 10.181 4.96527 10.9416 6.17847 12.1548C7.39167 13.368 8.15224 14.9605 8.33329 16.6666M1.66663 13.3333C2.49384 13.4874 3.25502 13.8883 3.85001 14.4833C4.44499 15.0783 4.8459 15.8394 4.99996 16.6666M1.66663 16.6666H1.67496",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCast);
export default __webpack_public_path__ + "static/media/small-cast.16bb434ea0790242ddb55d0f988834de.svg";
export { ForwardRef as ReactComponent };